<template>
  <div>
    <b-card >
      <b-nav tabs class="nav-tabs-custom">
        <b-nav-item :to="{ name: 'guide-hotel' }" exact exact-active-class="active">Hotel</b-nav-item>
        <b-nav-item :to="{ name: 'guide-transfers' }" exact exact-active-class="active">Transfers</b-nav-item>
        <b-nav-item :to="{ name: 'guide-wifi' }" exact exact-active-class="active">Redes Wi-fi</b-nav-item>
        <b-nav-item :to="{ name: 'guide-activities' }" exact exact-active-class="active">Atividades</b-nav-item>
      </b-nav>
      <b-card-body class="main-content-default">
        <router-view></router-view>
      </b-card-body>
    </b-card>
  </div>
</template>
<script>
export default {
  name: 'ContentGuide',
  components: {},
  props: {
  },
  data () {
    return {
      chat: false
    }
  },
  created () {}
}
</script>
<style>
.main-content-default {min-height: 307px;}
.custom-control-input:checked ~ .custom-control-label::before {
    color: #fff;
    border-color: #5fc78a;
    background-color: #33b46d;
}
</style>
